import { render, staticRenderFns } from "./RecapsTab.vue?vue&type=template&id=32db361a&"
import script from "./RecapsTab.vue?vue&type=script&lang=js&"
export * from "./RecapsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32db361a')) {
      api.createRecord('32db361a', component.options)
    } else {
      api.reload('32db361a', component.options)
    }
    module.hot.accept("./RecapsTab.vue?vue&type=template&id=32db361a&", function () {
      api.rerender('32db361a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/customization-tabs/RecapsTab.vue"
export default component.exports